/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  var getBootstrapBreakpoint = function(){
      var w = $( document ).innerWidth();
      return (w < 544) ? 'xs' : ((w < 768) ? 'sm' : ((w < 992) ? 'md' : ((w < 1200) ? 'lg' : 'xl')));
  };

  var equal_heights = function (elementsToMatchHeights) {
    elementsToMatchHeights.forEach(function(element) {
      $(element.selector).matchHeight({ byRow: element.byRow });
    });
  };

  var update_heights = function (elementsToMatchHeights) {
    elementsToMatchHeights.forEach(function(element) {
      $(element.selector).matchHeight._update();
    });
  };

  var setup_anchors = function () {
      $('a')
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (event) {
          if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
              event.preventDefault();
              $('html, body').animate({
                scrollTop: target.offset().top - $('#header-container').height() - 2
              }, 500);
            }
          }
        }
      );
    };

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $(document).ready(function() {
          $('map').imageMapResize();
          setup_anchors();

          var header = $("#header-container");
          $(window).scroll(function() {
              var scroll = $(window).scrollTop();
              if (scroll >= 50) {
                  header.addClass("scrolled");
              } else {
                  header.removeClass("scrolled");
              }
          });

          if (typeof vars.services_active_region !== 'undefined') {
            jQuery.cookie('service_region', vars.services_active_region, jQuery.extend({}, { path: '/' }, { expires: 91 }));
          }
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        $( document ).ready( function() {
          $( '.owl-carousel' ).owlCarousel( {
            items:1,
            loop:true,
            nav:true,
            dots:true,
            autoplay:true,
            autoplayTimeout:8000,
            navText: ["",""],
            itemElement:'div',
          } );

          var $dropdown_text = $('#dropdown-text');
          var $dropdown_hidden_text = $('#dropdown-hidden-text');

          if( BootstrapViewport.is( '>=sm' ) ) {
            $dropdown_text.find('.dropdown-text-item:first-child .collapse').collapse('show');
          }

          // On collapsible block open event, show blocks controlled by it and hide every other collapsible sibling block
          $dropdown_text.on('show.bs.collapse','.collapse', function( e ) {
              var target_id = $( e.target ).attr( 'id' );

              $dropdown_text.find('.collapse.show[data-parent="' + $( e.target ).data( 'parent' ) + '"]').collapse('hide');
              $dropdown_hidden_text.find( '[data-controlled-by=\'' + target_id + '\']' ).collapse('show');
          });

          // On collapsible block close event, close blocks controlled by it
          $dropdown_text.on('hide.bs.collapse','.collapse', function( e ) {
              var target_id = $( e.target ).attr( 'id' );
              $dropdown_hidden_text.find( '[data-controlled-by=\'' + target_id + '\']' ).collapse('hide');
          });

          $( '.wheel-map area' ).hover(
            function(e) {
              var target_image = jQuery( e.currentTarget ).parent().parent().find('.hidden-image');
              var target_image_id = jQuery( e.currentTarget ).data('target-id');
              jQuery( target_image ).attr( 'src', jQuery( target_image ).data( 'img-' + target_image_id + '-src' ) );
            },
            function(e) {
              var target_image = jQuery( e.currentTarget ).parent().parent().find('.hidden-image');
              var target_image_id = jQuery( e.currentTarget ).data('target-id');
              jQuery( target_image ).attr( 'src', jQuery( target_image ).data( 'img-' + jQuery( target_image ).data( 'img-active' ) + '-src' ) );
            });

            $( '.wheel-map area' ).click( function(e) {
              e.stopPropagation();
              e.preventDefault();

              var target_image = jQuery( e.currentTarget ).parent().parent().find('.hidden-image');
              jQuery('.hidden-text-placeholder').hide();
              var target_image_id = jQuery( e.currentTarget ).data('target-id');
              var target_text_sel = jQuery( e.currentTarget ).data('target-text');

              jQuery( target_image ).data( 'img-active', target_image_id );
              jQuery( target_image ).attr( 'src', jQuery( target_image ).data( 'img-' + jQuery( target_image ).data( 'img-active' ) + '-src' ) );

              jQuery( '.hover-text .hidden-text').collapse('hide');
              jQuery( '.hover-text.' + target_text_sel + ' .hidden-text').collapse('show');
              var scroll_margin = (jQuery( '#dropdown-hidden-text .show .hidden-image-container').height() / 4) * 3;
              jQuery('html, body').animate({
                scrollTop: jQuery( '#dropdown-hidden-text .hidden-text-container').offset().top - scroll_margin
              }, 500);
            } );
        });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Services Child page
    'page_template_tpl_services_child_page': {
      init: function() {
        // JavaScript to be fired on the services-child-page
        $( document ).ready( function() {

          var heightMatchesServicesChildPage = [
            { selector: '.section-offices .office-list .office .office-title', byRow: true },
            { selector: '.section-services .services-list .service', byRow: false }
          ];

          equal_heights(heightMatchesServicesChildPage);
        });
      },
      finalize: function() { }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

var md = new MobileDetect(window.navigator.userAgent);
var BootstrapViewport = ResponsiveBootstrapToolkit;
BootstrapViewport.breakpoints = {
  'xs': jQuery('<div class="d-xs-block d-sm-none d-md-none d-lg-none d-xl-none"></div>'),
  'sm': jQuery('<div class="d-none d-sm-block d-md-none d-lg-none d-xl-none"></div>'),
  'md': jQuery('<div class="d-none d-md-block d-sm-none d-lg-none d-xl-none"></div>'),
  'lg': jQuery('<div class="d-none d-lg-block d-sm-none d-md-none d-xl-none"></div>'),
  'xl': jQuery('<div class="d-none d-xl-block d-sm-none d-md-none d-lg-none"></div>'),
};
